export function CateringContractTermsAndConditions() {
  return (
    <section className="p-4 overflow-x-auto bg-white rounded-lg">
      <section id="terms-and-condition" className="!w-[1000px] lg:!w-full">
        <div
          style={{
            backgroundColor: "black",
            color: "white",
            textAlign: "center",
          }}
        >
          <h1>TERMS AND CONDITIONS</h1>
        </div>
        <div>
          <h4>Billing Arrangement</h4>

          <p>
            Event reservation shall be made at least 15 days before the event
            date. Client shall be required to sign this contract and make a{" "}
            <u>
              {" "}
              deposit or down payment of 50% of the total contract price upon
              signing; 50% balance shall be paid on the day of the event
            </u>
            . Payment shall be made in cash or check. Please make check payable
            to <u>Company Name</u>
          </p>

          <br />

          <h4>Contract Modification</h4>
          <p>
            The guaranteed minimum number indicated in the contract is
            considered final upon signing of the contract. No refund shall be
            made if the actual number of guests fall below that of the minimum
            number of contracted guests. The client shall advise the Caterer of
            any changes or modifications (number of guests, set up, venue, and
            the like) at least three (3) days before the actual date. Charges
            for additional guests shall be made per contract rate. Should the
            Caterer fail to deliver the agreed number of food for the minimum
            guaranteed guests for the reason of non-availability of raw
            materials, the Caterer shall be allowed to replace the menu from
            among the options presented in the Menu Packages given to the Client
            subject to prior notice and consent of the client.
          </p>

          <br />

          <h4>Cancellation Policy</h4>

          <p>
            Client is required to submit a formal notice of cancellation to
            Caterer stating reason of cancellation. Should contract be
            cancelled;
            <br />
            • One hundred (100%) of the total deposit shall be refunded if the
            cancellation is made at least fifteen (15) days prior to event
            schedule.
            <br />
            • Fifty percent (50%) of the total deposit shall be refunded if the
            cancellation is made six (6) days prior to the said event date.
            <br />
            • No refund shall be made from the total deposit if cancellation is
            made three (3) days before the event date to cover for the expenses
            incurred in the preparations for the event.
            <br />
            <br />
            In the event that a refund of down payment is allowed, the refund
            will be in the form of a check and may be claimed within 10 working
            days upon approval of refund.
          </p>

          <br />

          <h4>Non-Compliance to Payment Scheme</h4>

          <p>
            If the required deposit or down payment is not received on the
            scheduled date, reservation will be subject to cancellation and
            notice will be given to the client.Our Company reserves the right to
            cancel the reservation if the signed contract and down payment are
            not received seven (7) days before the event date.Should the client
            fail to pay the balance on the agreed date, a 2% interest per month
            on the balance shall be applied.
          </p>

          <br />

          <h4>Product Quality</h4>

          <p>
            The Caterer hereby warrants that the food and beverages that will be
            served shall all be clean, safe and in good quality. The Caterer
            shall deliver the agreed quantity of food packages stipulated in
            this contract and will maintain its high standard of quality for all
            the products. However, if the food is not consumed within three (3)
            hours after food is delivered to the guests or within the agreed
            function time, Client shall assume full responsibility for any
            damage/s, if any, suffered by the guest concerned attributed to the
            food or beverage served. Likewise, the Caterer is not liable for any
            damage/s resulting from other food and/or beverage served outside
            that which is specified in this Contract.
          </p>

          <br />

          <h4>Ingress/Egress</h4>

          <p>
            All permits and coordination with venue administrator for the
            ingress and egress shall be the responsibility of the Client. Should
            there be a need for cooking equipment that requires specific
            electrical provision, Client will be informed one week prior to the
            event date. In cases where the venue administrator will charge for
            the use of the venue facilities, the cost shall be for the account
            of the Client.
          </p>

          <br />

          <h4>Exclusion of Liability</h4>

          <p>
            The Caterer will not be held liable for failure to execute
            obligations specified herein directly or indirectly occasioned by or
            in consequence of war, change of statutes to the Philippine
            Government, political issues/disturbances that is/are life and
            safety threatening, strikes, riots, and other civil disturbances,
            typhoons, floods, natural calamities and other acts of God, fire or
            such other conditions and events beyond the control of the company.
            In the event of non-performance due to any of the above reasons, our
            company shall refund, in full, payment received for this function.
          </p>
        </div>

        <table
          style={{ width: "100%", marginTop: 20, color: "black", fontSize: 14 }}
        >
          <tr>
            <th style={{ fontWeight: "bold", textAlign: "center" }}>
              Prepared by:{" "}
            </th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}>
              Approved by:{" "}
            </th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
          </tr>
          <tr>
            <td
              style={{
                width: "30%",
                borderBottom: "1px solid black",
                height: 50,
              }}
            ></td>
            <td style={{ width: "3%" }}></td>
            <td
              style={{
                width: "13.5%",
                borderBottom: "1px solid black",
                height: 50,
              }}
            ></td>
            <td style={{ width: "7%" }}></td>
            <td
              style={{
                width: "30%",
                borderBottom: "1px solid black",
                height: 50,
              }}
            ></td>
            <td style={{ width: "3%" }}></td>
            <td
              style={{
                width: "13.5%",
                borderBottom: "1px solid black",
                height: 50,
              }}
            ></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td style={{ fontWeight: "bold", textAlign: "center" }}>Date:</td>
            <td></td>
            <td></td>
            <td></td>
            <td style={{ fontWeight: "bold", textAlign: "center" }}>Date:</td>
          </tr>

          <tr>
            <td
              style={{
                fontWeight: "bold",
                textAlign: "center",
                fontSize: 14,
                fontStyle: "italic",
              }}
            >
              Taters Representative
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td
              style={{
                fontWeight: "bold",
                textAlign: "center",
                fontSize: 14,
                fontStyle: "italic",
              }}
            >
              Store Manager / Managing Partner
            </td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <th
              style={{
                fontWeight: "bold",
                textAlign: "center",
                paddingTop: 25,
              }}
            >
              Conforme:
            </th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
            <th style={{ fontWeight: "bold", textAlign: "center" }}></th>
          </tr>

          <tr>
            <td
              style={{
                width: "30%",
                borderBottom: "2px solid black",
                height: 50,
              }}
            ></td>
            <td style={{ width: "3%" }}></td>
            <td
              style={{
                width: "13.5%",
                borderBottom: "2px solid black",
                height: 50,
              }}
            ></td>
            <td style={{ width: "7%" }}></td>
            <td style={{ width: "30%" }}></td>
            <td style={{ width: "3%" }}></td>
            <td style={{ fontWeight: "bold", width: "13.5%" }}></td>
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td style={{ fontWeight: "bold", textAlign: "center" }}>Date:</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>

          <tr>
            <td
              style={{
                fontWeight: "bold",
                textAlign: "center",
                fontSize: 14,
                fontStyle: "italic",
              }}
            >
              Client
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </section>
    </section>
  );
}
